import { render, staticRenderFns } from "./request-documents-step.vue?vue&type=template&id=769a570b"
import script from "./request-documents-step.vue?vue&type=script&lang=js"
export * from "./request-documents-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports